export default "__VITE_ASSET__uTfr_eDB__"